import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-2 bg-white" }
const _hoisted_2 = { class: "table table-striped" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggler = _resolveComponent("toggler")!
  const _component_accordion = _resolveComponent("accordion")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localValue, (value, key, i) => {
    return (_openBlock(), _createBlock(_component_accordion, { class: "mb-3" }, {
      title: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("span", null, [
            _cache[2] || (_cache[2] = _createTextVNode("Modulo ")),
            _createElementVNode("b", null, _toDisplayString(key), 1),
            (Object.keys(value).length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" (" + _toDisplayString(Object.keys(value).length) + " elementi) ", 1)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("table", _hoisted_2, [
            _createElementVNode("thead", null, [
              _createElementVNode("th", null, [
                _cache[3] || (_cache[3] = _createTextVNode(" Field name (in crucco) ")),
                _createElementVNode("button", {
                  class: "btn btn-success",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showFieldName = !_ctx.showFieldName))
                }, " + ")
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("th", null, "Tipo campo", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("th", null, "Escludi", -1))
            ]),
            _createElementVNode("tbody", null, [
              (_ctx.showFieldName)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                    _createElementVNode("td", null, [
                      _createElementVNode("form", {
                        class: "d-flex align-items-center",
                        onSubmit: _withModifiers(($event: any) => (_ctx.addFieldConfigTo(value)), ["prevent"])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tempFieldName) = $event)),
                          ref_for: true,
                          ref: "tempFieldInput"
                        }, null, 512), [
                          [_vModelText, _ctx.tempFieldName]
                        ]),
                        _cache[6] || (_cache[6] = _createElementVNode("button", { class: "btn btn-primary" }, " OK ", -1))
                      ], 40, _hoisted_4)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (config, fieldName, i) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      class: "btn btn-danger btn-sm",
                      onClick: ($event: any) => (_ctx.removeFrom(fieldName as string, value))
                    }, "-", 8, _hoisted_5),
                    _createTextVNode(" " + _toDisplayString(fieldName), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": ($event: any) => ((config.type) = $event)
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataTypes, (it) => {
                        return (_openBlock(), _createElementBlock("option", null, _toDisplayString(it), 1))
                      }), 256))
                    ], 8, _hoisted_6), [
                      [_vModelSelect, config.type]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_toggler, {
                      modelValue: config.exclude,
                      "onUpdate:modelValue": ($event: any) => ((config.exclude) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ])
                ]))
              }), 256))
            ])
          ])
        ])
      ]),
      _: 2
    }, 1024))
  }), 256))
}